






























































































import { Vue, Component } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { EplItemStatus, eplItemStatusIconMap, EplLookupMethod } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import SigisLicenseAgreement from "@/employee/components/product-scanner/SigisLicenseAgreement.vue";
import BarcodeReader from "@/employee/components/product-scanner/BarcodeReader.vue";
import BarcodeReaderV2 from "@/employee/components/product-scanner/BarcodeReaderV2.vue";
import { isCapacitorAvailable } from "@/shared/mobileHelper";
import { useProductScannerStore } from "@/employee/store/productScanner";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {
    GenericLoadingSpinner,
    SigisLicenseAgreement,
    BarcodeReader,
    BarcodeReaderV2
  }
})
export default class ProductScanner extends Vue {
  $validator: Validator;

  productScannerStore = useProductScannerStore();
  signingDocumentStore = useSigningDocumentStore();
  hsabAccountsStore = useHsabAccountsStore();

  manualEntry = false;
  productCode = "";
  statusIcon = eplItemStatusIconMap[EplItemStatus.None];
  statusMessage = "";
  showScanner = false;

  get scanOptionsHeader () {
    return this.productScannerStore.awaitingScan
      ? "Select an option below:"
      : "Check eligibility of another product:";
  }

  mounted () {
    this.productScannerStore.initializeState();
  }

  onManualEntryClick () {
    this.manualEntry = true;
    this.$nextTick(() => {
      (this.$refs.productCodeInput as any).focus();
    });
  }

  lookupProductCode () {
    this.$validator.validate()
      .then(isValid => {
        if (!isValid) {
          return;
        }

        this.lookup(this.productCode, EplLookupMethod.ManualEntry);
      });
  }

  lookup (productCodeString: string, method: EplLookupMethod) {
    this.productScannerStore.lookupItem({ productCode: productCodeString, method })
      .then(response => {
        this.statusIcon = eplItemStatusIconMap[response.status];
        this.statusMessage = response.statusMessage;
        this.manualEntry = false;
        this.productCode = "";
      })
      .catch(() => {/* noop */ });
  }

  openScannerWindow () {
    this.showScanner = true;
  }

  onScannerSuccess (barcode: string) {
    this.showScanner = false;
    this.lookup(barcode, EplLookupMethod.Scan);
  }

  onScannerClose () {
    this.showScanner = false;
  }

  get useVersion2 () {
    return isCapacitorAvailable();
  }

  get showDisclaimer () {
    return this.hsabAccountsStore.userHasAnyNotionalAccounts;
  }
}
